import axios from "axios";

const apiUrl = process.env.REACT_APP_API_URL;

export function login(email, password) {
  return axios.post(`${apiUrl}/auth/login`, { email, password });
}
